import { IReduxAction } from '@bees-web/core/types'
import { ALERT_DISPLAYED } from '../constants'
import { AlertDisplayed } from '../typewriter'

export interface AlertDisplayedExtended extends AlertDisplayed {
  alert_label: string
}

export interface AlertDisplayedAction extends IReduxAction {
  payload: AlertDisplayedExtended
}

export const trackAlertDisplayed = (
  alertName: string,
  pocId?: string,
  referrer?: string,
  screenName?: string,
  alertType: string = null,
  sku: string = null,
  vendorId: string = null,
  store_id = '',
  value_stream = '',
  alert_label = '',
  itemId = null
): AlertDisplayedAction => ({
  type: ALERT_DISPLAYED,
  payload: {
    alert_name: alertName,
    alert_type: alertType,
    invoice_id: null,
    poc_id: pocId,
    referrer,
    screen_name: screenName,
    sku: sku,
    vendorId,
    store_id,
    value_stream,
    alert_label,
    itemId,
  },
})
